import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Header.css';

const Header = ({ isNavbarVisible }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${isNavbarVisible ? 'scrolled visible' : 'hidden'}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <h2>Sonty & Gavin</h2>
          </Link>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li>
                <Link 
                  to="/" 
                  className={location.pathname === '/' ? 'active' : ''}
                  onClick={handleNavClick}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/accommodations" 
                  className={location.pathname === '/accommodations' ? 'active' : ''}
                  onClick={handleNavClick}
                >
                  Accommodations
                </Link>
              </li>
              <li>
                <Link 
                  to="/schedule" 
                  className={location.pathname === '/schedule' ? 'active' : ''}
                  onClick={handleNavClick}
                >
                  Schedule
                </Link>
              </li>
              <li>
                <Link 
                  to="/faq" 
                  className={location.pathname === '/faq' ? 'active' : ''}
                  onClick={handleNavClick}
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </nav>

          <button className="menu-toggle" onClick={toggleMenu}>
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
